<template>
  <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/Bibimbap">Bibimbap</router-link> |
    <router-link to="/Bulgogi">Bulgogi</router-link> |
    <router-link to="/Kimbap">Kimbap</router-link> |
    <router-link to="/Tempura">Tempura</router-link> |
    <router-link to="/Dumpling">Dumpling</router-link> |
    <router-link to="/FriedRice">Fried Rice</router-link> |
    <router-link to="/Combo">Combo</router-link> |
    <router-link to="/Noodle">Noodle</router-link> |
    <router-link to="/Jjigae">Jjigae</router-link> |
    <router-link to="/Soup">Soup</router-link> |
    <router-link to="/SpicyBowls">Spicy Bowls</router-link> |
    <router-link to="/SideDish">Side Dish</router-link> |
    <router-link to="/SmallPlates">Small Plates</router-link> |    
    <router-link to="/JapchaeTteokbokki">Japchae & Tteokbokki</router-link> |
    <router-link to="/KoreanPancake">Korean Pancake</router-link> |
    <router-link to="/Drinks">Drinks</router-link> 

  </nav>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: darkblue;
}
</style>
